import { DraftCloseActionSelectModal } from '../../Draft'

function RequestDraftCloseActionSelectModal(props) {
  return (
    <DraftCloseActionSelectModal
      {...props}
      cancelTextKey='Request.CloseConfirmationCancelKey'
      discardLabelKey='Request.CloseConfirmationDiscardKey'
      formFieldsProps={{ titleKey: 'Request.CloseConfirmationActionTitleKey' }}
      saveLabelKey='Request.CloseConfirmationSaveKey'
      submitTextKey='Request.CloseConfirmationSubmitKey'
      titleKey='Request.CloseConfirmationTitleKey'
    />
  )
}

export default RequestDraftCloseActionSelectModal
